import { API_AUTH_WebMorman } from "../common";

const thongBaoThongTinVayApi = {
  checkQuyenHienThi: (IdCuaHang) =>
  API_AUTH_WebMorman.get(
      `ThongTinAPI/CheckDangKyNhanThongTin?IdCuaHang=${IdCuaHang}`,
      {}
    ),
  danhSachDangKyVay: (data) =>
  API_AUTH_WebMorman.get(
      `ThongTinAPI/DanhSachDangKyVay?IdCuaHang=${data.IdCuaHang}&sHoVaTen=${data.sHoVaTen}&LoaiDangKy=${data.LoaiDangKy}&iPageIndex=${data.iPageIndex}&iPageSize=${data.iPageSize}`,
      {}
    ),
  getSoLuongDataMoi: (IdCuaHang, date) =>
  API_AUTH_WebMorman.get(
      `ThongTinAPI/CountDangKyVayMoi?IdCuaHang=${IdCuaHang}&date=${date}`,
      {}
    ),
};
export default thongBaoThongTinVayApi;
